import React from "react";
import ReactDOM from "react-dom";
import ConfirmDialog from "../components/ConfirmDialog";

const IS_REACT_16 = !!ReactDOM.createPortal;
const destroyFns = [];

/**
 * ModalConfirm extends from antd Modal.confirm
 * @param {*} config an object extends from antd Modal's props
 */
// eslint-disable-next-line max-lines-per-function
const show = config => {
  const div = document.createElement("div");
  document.body.appendChild(div);
  // eslint-disable-next-line no-use-before-define
  let currentConfig = { ...config, close, visible: true };

  // eslint-disable-next-line complexity
  function destroy(...args) {
    const unmountResult = ReactDOM.unmountComponentAtNode(div);
    if (unmountResult && div.parentNode) {
      div.parentNode.removeChild(div);
    }
    const triggerCancel = args.some(param => param && param.triggerCancel);
    if (config.onCancel && triggerCancel) {
      config.onCancel(...args);
    }
    for (let i = 0; i < destroyFns.length; i += 1) {
      const fn = destroyFns[i];
      // eslint-disable-next-line no-use-before-define
      if (fn === close) {
        destroyFns.splice(i, 1);
        break;
      }
    }
  }

  function render(props) {
    ReactDOM.render(<ConfirmDialog {...props} />, div);
  }

  function close(...args) {
    currentConfig = {
      ...currentConfig,
      visible: false,
      afterClose: destroy.bind(this, ...args)
    };
    if (IS_REACT_16) {
      render(currentConfig);
    } else {
      destroy(...args);
    }
  }

  function update(newConfig) {
    currentConfig = {
      ...currentConfig,
      ...newConfig
    };
    render(currentConfig);
  }

  render(currentConfig);

  destroyFns.push(close);

  return {
    destroy: close,
    update
  };
};

export default { show };



// WEBPACK FOOTER //
// ./src/services/confirmModal.tsx